module.exports = __webpack_public_path__ + "cornerSprite-00066e4703b3689be8c571a87f7c1a02.png";